import React from 'react';
import {
  Button,
  LoadingButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { IMappedAddress } from '../../../models/common/addresses';
import { AddressParagraph } from '../address-paragraph/address-paragraph';
import { IModalBasicProps } from '../../../models/common/modal';

export const ICDefaultAddressMsg =
  "This is also your address for Instant Checkout. You'll need to set up where you get items before you shop with Instant Checkout again.";

interface IDeleteAddressProps extends IModalBasicProps {
  address: IMappedAddress;
  onConfirmDelete: () => void;
  isLoading: boolean;
}

export const DeleteAddressModal: React.FC<IDeleteAddressProps> = ({
  address,
  hideModal,
  onConfirmDelete,
  isLoading,
}: IDeleteAddressProps) => {
  return (
    <>
      <ModalHeader onClose={hideModal}>
        Do You Want To Delete This Address?
      </ModalHeader>
      <ModalBody>
        <AddressParagraph address={address} />
        {address.instantCheckoutDefault && (
          <div className="sui-mt-4">
            <Typography>{ICDefaultAddressMsg}</Typography>
          </div>
        )}
      </ModalBody>
      <ModalFooter position="end">
        <div className="sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto">
          <Button variant="secondary" onClick={hideModal}>
            No
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="primary"
            onClick={onConfirmDelete}
            data-testid="confirm-delete-address-btn"
          >
            Yes, Delete Address
          </LoadingButton>
        </div>
      </ModalFooter>
    </>
  );
};

DeleteAddressModal.displayName = 'DeleteAddressModal';
